export default __webpack_public_path__ + "static/media/verify_gr.8524f3e9.jpg";